export const GET_CONTACTS_START = "GET_CONTACTS_START";
export const GET_CONTACTS_SUCCESS = "GET_CONTACTS_SUCCESS";
export const GET_CONTACTS_FAILED = "GET_CONTACTS_FAILED";

export const BLOCK_CONTACTS_START = "BLOCK_CONTACTS_START";
export const BLOCK_CONTACTS_SUCCESS = "BLOCK_CONTACTS";
export const BLOCK_CONTACTS_FAIL = "BLOCK_CONTACTS_FAIL";

export const DELETE_CONTACTS_START = "DELETE_CONTACTS_START";
export const DELETE_CONTACTS_SUCCESS = "DELETE_CONTACTS";
export const DELETE_CONTACTS_FAIL = "DELETE_CONTACTS_FAIL";

export const NEW_CONTACTS_SUCCESS = "NEW_CONTACTS_SUCCESS";

export const SHOW_CUSTOMER_DETAILS_IN_CONTACTS_PAGE = "SHOW_CUSTOMER_DETAILS_IN_CONTACTS_PAGE";

export const EMPTY_CONTACTS_LIST = "EMPTY_CONTACTS_LIST";
